import { css } from 'styled-components';

const styles = {
  rootContainer: css`
    flex: 1;
  `,
  rowContainer: css`
    height: 100%;
    margin-bottom: 50px;

    h1 a {
    position: relative;
      transition: opacity 200ms ease-in-out;
      &:hover {
        opacity: 0.6;
      }
    }
  `,
  nav: css`
    display: flex;
    align-items: center;
  `
};

export default styles;
